export const NOT_YET_BEGUN = 0;
export const UNDERSTANDING = 1;
export const CLARIFYING = 2;
export const WAITING_REPLY = 3;
export const MARK_QUESTION_COMPLETE = 4;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/constants/answerStages.js